import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { DialogQoeResultGridLayoutService } from './dialog-qoe-result.grid-layout.service';
import { InventoryService } from '@irb/irb-orders/order-blotter/inventory/inventory.service';
import { IAlertDialogData } from "@irb/app.model";

@Component({
  selector: 'irb-dialog-qoe-result',
  standalone: false,
  templateUrl: './dialog-qoe-result.component.html',
  styleUrl: './dialog-qoe-result.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogQoeResultComponent implements OnInit {
  grid: any;
  gridOptions: any;
  progressTimer: any = null;
  updateStatusCount = 0;
  isUiTest = false;
  frameworkComponents: any;
  data: any;
  onProceed: Function;

  constructor(
    public dialogRef: MatDialogRef<DialogQoeResultComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    public as: AppService,
    private gls: DialogQoeResultGridLayoutService,
    public pfs: InventoryService
  ) {
    this.data = mdd.data;
    this.onProceed = mdd.onProceed;
  }

  ngOnInit() {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  proceed() {
    this.onProceed(this.data);
    this.close();
  }
}
